export abstract class DeviceService {
  abstract isMobileDevice(): boolean;
  abstract isSafariBrowser(): boolean;
}
